import React from 'react';
import './ProfilePlaceholderPage.css';

const ProfilePlaceholderPage = () => {
  return (
    <div className="profile-placeholder-container">
      <div className="profile-placeholder-content">
        <div className="construction-icon">
          <span role="img" aria-label="construction">🔨</span>
          <span role="img" aria-label="construction">🔧</span>
        </div>
        <h1>This page is under construction</h1>
        <p>Thanks for visiting our page!</p>
      </div>
    </div>
  );
};

export default ProfilePlaceholderPage;
